import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GoodsTransferDetails } from './Pages';

export const GoodsTransferDetailsRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={GoodsTransferDetails} />
       
    </Fragment>
)